import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { obterDadosRendaAtualizada, obterDadosRendaCNIS, obterIntegrantesFamilia, obterTrabalhoERendaPessoa } from '../../api/rendaAPI';
import { RootState } from '../../app/store';
import * as Mensagens from '../../common/Mensagens';
export interface ConsultaRendaState {
  familiaSemRegistroCivil: boolean;
  numeroFamiliar: number;
  familia: any;
  membroSelecionado: any;
  integrantesFamiliares: any[];
  dadosRendaCNIS: any[];
  dadosRendaAtualizada: any[];
  dadosTrabalhoERendaPessoa: any;
  sistemaParceiroIndisponivel: boolean;
  isRendaIdentificada: boolean;
  dadosPessoaSelecionada: any;
}

const initialState: ConsultaRendaState = {
  familiaSemRegistroCivil: false,
  numeroFamiliar: 0,
  familia: null,
  membroSelecionado: null,
  integrantesFamiliares: [],
  dadosRendaCNIS: [],
  dadosRendaAtualizada: [],
  dadosTrabalhoERendaPessoa: '',
  sistemaParceiroIndisponivel: false,
  isRendaIdentificada: false,
  dadosPessoaSelecionada: []
};

export const getIntegrantes = createAsyncThunk(
  'consultaRenda/getIntegrantes',
  async (numeroFamiliar: number) => {
    return await obterIntegrantesFamilia(numeroFamiliar);
  }
);

export const getDadosRendaCNIS = createAsyncThunk(
  'consultaRenda/getDadosRendaCNIS',
  async (dados: any, thunkAPI) => {
    const state:any = thunkAPI.getState(); // Obtém o estado atual do Redux
    const dadosRendaIdentificada = state.consultaRenda.dadosRendaCNIS;
    const idPessoa = dados.idPessoa;

    const dadoEncontrado = dadosRendaIdentificada.find(dado => dado.idPessoa == idPessoa);

    if (!dadoEncontrado) {
      const dadosRenda = await obterDadosRendaCNIS(dados.idPessoa, dados.nuFamiliar, dados.cpf);
      return {idPessoa, dadosRenda};
    }

    return "";
  }
);

export const getDadosRendaAtualizada = createAsyncThunk(
  'consultaRenda/getDadosRendaAtualizada',
  async (dados: any, thunkAPI) => {
    const state:any = thunkAPI.getState(); // Obtém o estado atual do Redux
    const dadosRendaAtualizada = state.consultaRenda.dadosRendaAtualizada;
    const idPessoa = dados.idPessoa;

    const dadoEncontrado = dadosRendaAtualizada.find(dado => dado.idPessoa == idPessoa);

    if (!dadoEncontrado) {
      const dadosRenda = await obterDadosRendaAtualizada(dados.idPessoa, dados.nuFamiliar, dados.cpf);
      return {idPessoa, dadosRenda};
    }

    return "";
  }
);

export const getDadosTrabalhoRendaPessoa = createAsyncThunk(
  'consultaRenda/getDadosTrabalhoRendaPessoa',
  async (idPessoa: number) => {
    return await obterTrabalhoERendaPessoa(idPessoa);
  }
);

export const consultaRendaSlice = createSlice({
  name: 'consultaRenda',
  initialState,
  reducers: {
    limpar: (state) => {
      state.dadosRendaCNIS = [];
      state.dadosRendaAtualizada = [];
      state.familiaSemRegistroCivil = false;
      state.numeroFamiliar = 0;
      state.familia = null;
      state.membroSelecionado = null;
      state.integrantesFamiliares = [];
      state.dadosRendaCNIS = [];
      state.dadosRendaAtualizada = [];
      state.dadosTrabalhoERendaPessoa = '';
      state.sistemaParceiroIndisponivel = false;
      state.isRendaIdentificada = false;
      state.dadosPessoaSelecionada = [];
    },
    alterarNumeroFamiliar: (state, action) => {
      state.numeroFamiliar = action.payload;
    },
    alterarMembroSelecionado: (state, action) => {
      state.membroSelecionado = action.payload;
    },
    alterarFamiliaSemRegistroCivil: (state, action) => {
      state.familiaSemRegistroCivil = action.payload;
    },
    alterarSistemaParceiroIndisponivel: (state, action) => {
      state.sistemaParceiroIndisponivel = action.payload;
    },
    alterarRendaIdentificada: (state, action) => {
      state.isRendaIdentificada = action.payload;
    },
    alterarDadosPessoaSelecionada: (state, action) => {
      state.dadosPessoaSelecionada = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getIntegrantes.fulfilled, (state, action) => {
        state.integrantesFamiliares = action.payload;
      })
      .addCase(getIntegrantes.rejected, (state, {error}) => {
        if (error.message === "Família sem registro civil.") {
          state.familiaSemRegistroCivil = true;
        }
        if (error.message === Mensagens.MSG_TENTE_NOVAMENTE) {
          state.sistemaParceiroIndisponivel = true;
        }
      })
      .addCase(getDadosRendaCNIS.fulfilled, (state, action) => {
        if (action.payload === "") {
          state.dadosRendaCNIS = state.dadosRendaCNIS;
        } else {
          state.dadosRendaCNIS.push(action.payload);
        }
      })
      .addCase(getDadosRendaCNIS.rejected, (state, {error}) => {
        if (error.message === Mensagens.MSG_TENTE_NOVAMENTE) {
          state.sistemaParceiroIndisponivel = true;
        }
      })
      .addCase(getDadosRendaAtualizada.fulfilled, (state, action) => {
        if (action.payload === "") {
          state.dadosRendaAtualizada = state.dadosRendaAtualizada;
        } else {
          state.dadosRendaAtualizada.push(action.payload);
        }
      })
      .addCase(getDadosRendaAtualizada.rejected, (state, {error}) => {
        if (error.message === Mensagens.MSG_TENTE_NOVAMENTE) {
          state.sistemaParceiroIndisponivel = true;
        }
      })
      .addCase(getDadosTrabalhoRendaPessoa.fulfilled, (state, action) => {
        state.dadosTrabalhoERendaPessoa = action.payload;
      })
      .addCase(getDadosTrabalhoRendaPessoa.rejected, (state, {error}) => {
        if (error.message === Mensagens.MSG_TENTE_NOVAMENTE) {
          state.sistemaParceiroIndisponivel = true;
        }
      })
  },
});

export const { limpar, alterarNumeroFamiliar, alterarMembroSelecionado,
  alterarFamiliaSemRegistroCivil, alterarSistemaParceiroIndisponivel,
  alterarRendaIdentificada, alterarDadosPessoaSelecionada } = consultaRendaSlice.actions;

export const selectState = (state: RootState) => state.consultaRenda;
export const selectIntegrantes = (state: RootState) => state.consultaRenda.integrantesFamiliares;
export const selectDadosRendaCNIS = (state: RootState) => state.consultaRenda.dadosRendaCNIS;
export const selectDadosRendaAtualizada = (state: RootState) => state.consultaRenda.dadosRendaAtualizada;
export const selectDadosTrabalhoERenda = (state: RootState) => state.consultaRenda.dadosTrabalhoERendaPessoa;
export const selectMembro = (state: RootState) => state.consultaRenda.membroSelecionado;
export const selectFamiliaSemRegistroCivil = (state: RootState) => state.consultaRenda.familiaSemRegistroCivil;
export const selectSistemaParceiroIndisponivel = (state: RootState) => state.consultaRenda.sistemaParceiroIndisponivel;
export const selectIsRendaIdentificada = (state: RootState) => state.consultaRenda.isRendaIdentificada;
export const selectDadosPessoaSelecionada = (state: RootState) => state.consultaRenda.dadosPessoaSelecionada;

export default consultaRendaSlice.reducer;
